import SERVICES from '@/constants/services';
export const routes = [
    {
        path: '/',
        name: 'mainPage',
        component: () => import('@/views/mainPage.vue'),
        beforeEnter(to, from, next) {
            window.location.href = SERVICES.NEW_BINANCE;
        },
        meta: {
            title: 'Главная',
            description: ''
        }
    },
    {
        path: '/leveragesPage',
        name: 'leveragesPage',
        component: () => import('@/views/leveragesPage.vue'),
        meta: {
            title: 'Плечи',
            description: ''
        }
    },
    {
        path: '/bonus',
        name: 'bonus',
        component: () => import('@/views/BonusesView.vue'),
        meta: {
            title: 'Бонусы',
            description: ''
        }
    },
    {
        path: '/buddy',
        name: 'buddy',
        component: () => import('@/views/BuddyView.vue'),
        meta: {
            title: 'Buddy',
            description: ''
        }
    },
    {
        path: '/transfers',
        name: 'transfersPage',
        component: () => import('@/views/transfersPage.vue'),
        meta: {
            title: 'Переводы',
            description: ''
        },
        redirect: { name: 'innerTransfers' },
        children: [
            {
                path: '',
                name: 'innerTransfers',
                component: () => import('@/components/pages/transfersPage/components/transfersHistory/components/historyTables/innerTransfers/index.vue'),
                meta: {
                    title: 'Внутренние переводы',
                    description: ''
                }
            },
            {
                path: 'outerTransfers',
                name: 'outerTransfers',
                component: () => import('@/components/pages/transfersPage/components/transfersHistory/components/historyTables/outerTransfers/index.vue'),
                meta: {
                    title: 'Внешние переводы',
                    description: ''
                }
            },
            {
                path: 'between-exchanges',
                name: 'betweenExchangesTransfers',
                component: () => import('@/components/pages/transfersPage/components/transfersHistory/components/historyTables/betweenExchanges/index.vue'),
                meta: {
                    title: 'Переводы между биржами',
                    description: ''
                }
            }
        ]
    },
    {
        path: '/spot',
        name: 'spot',
        component: () => import('@/views/spotPage.vue'),
        redirect: { name: 'spotTrade' },
        meta: {
            title: 'Спотовый кошелек',
            description: ''
        },
        children: [
            {
                path: '',
                name: 'spotTrade',
                meta: {
                    title: 'Спотовый кошелек',
                    description: ''
                },
                component: () => import('@/components/pages/spotPage/trade/index.vue')
            },
            {
                path: 'history',
                name: 'spotHistory',
                meta: {
                    title: 'История',
                    description: ''
                },
                component: () => import('@/components/pages/spotPage/history/index.vue')
            }
        ]
    },
    {
        path: '/whitelists',
        name: 'whitelists',
        component: () => import('@/views/whitelists.vue'),
        meta: {
            title: 'Белый список кошельков',
            description: ''
        },
        redirect: { name: 'whitelistsIndex' },
        children: [
            {
                path: '',
                name: 'whitelistsIndex',
                component: () => import('@/components/pages/whitelists/main/index.vue'),
                meta: {
                    title: 'Белый список кошельков',
                    description: ''
                }
            },
            {
                path: 'resolveNetworks',
                name: 'whitelistsResolveNetworksPage',
                component: () => import('@/components/pages/whitelists/resolveNetworks/index.vue'),
                meta: {
                    title: 'Редактирование кошельков',
                    description: ''
                }
            }
        ]
    },
    {
        path: '/api-keys',
        name: 'apiKeys',
        component: () => import('@/views/apiKeysPage.vue'),
        meta: {
            title: 'API-ключи',
            description: ''
        }
    },
    {
        path: '/gateway',
        name: 'gateway',
        component: () => import('@/views/gateway.vue'),
        meta: {
            title: '',
            description: ''
        }
    },
    {
        path: '/error',
        name: 'errorPage',
        component: () => import('@/views/404.vue'),
        meta: {
            title: 'Ошибка',
            description: ''
        }
    },
    {
        path: '/bonus-rules',
        name: 'bonusRulesPage',
        component: () => import('@/views/bonusAccrualPage.vue'),
        meta: {
            title: 'Начисление бонусов',
            description: ''
        }
    },
    {
        path: '/error/:code',
        name: 'NamedErrorPage',
        component: () => import('@/views/errorPage.vue'),
        meta: {
            title: 'Error',
            description: ''
        }
    },
    {
        path: '/access-repair/',
        name: 'AccessRepair',
        beforeEnter(to, from, next) {
            const secondFactor = `secondFactor=${to.query.secondFactor}`;
            const sessionId = `an3K8QkkJb3Mzz=${to.query.an3K8QkkJb3Mzz}`;
            window.location.href = `${SERVICES.PASSPORT}/access-repair?${secondFactor}&${sessionId}`;
        }
    },
    {
        path: '/multi-assets-faq',
        name: 'multiAssetsFaqPage',
        component: () => import('@/views/multiAssetsFaqPage.vue'),
        meta: {
            title: 'FAQ Мультиактивы',
            description: ''
        }
    },
    {
        path: '*',
        redirect: { name: 'errorPage' },
        meta: {
            title: 'Error',
            description: ''
        }
    }
];
